import { createContext, useContext } from 'react';

/**
 * All TC Run sections (Ratings, Notes for Collator, Confidential Notes, ...) mutate
 * the same AppraisalEntity on the backend and therefore share a single rowVersion.
 * Firing two mutations back-to-back from different sections (or even the same one)
 * with the cached rowVersion produces a 409 on the second one.
 *
 * This queue strictly serializes those mutations at the page level. See the
 * provider component for implementation details of the invariants.
 */
export interface TcRunAppraiseeMutationQueue {
  runSerialized: <T>(mutationFn: (rowVersion: string) => Promise<T>) => Promise<T>;
}

export const TcRunAppraiseeMutationQueueContext = createContext<TcRunAppraiseeMutationQueue | null>(
  null
);

export function useTcRunAppraiseeMutationQueue(): TcRunAppraiseeMutationQueue {
  const ctx = useContext(TcRunAppraiseeMutationQueueContext);
  if (!ctx) {
    throw new Error(
      'useTcRunAppraiseeMutationQueue must be used inside <TcRunAppraiseeMutationQueueProvider>'
    );
  }
  return ctx;
}
